import { render } from "./InventoryStoreView.vue?vue&type=template&id=6d799940"
import script from "./InventoryStoreView.vue?vue&type=script&lang=js"
export * from "./InventoryStoreView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__